// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2wSg0","noInteraction":"EventWrapper_noInteraction__1kdWW","pointerPassthrough":"EventWrapper_pointerPassthrough__2FWYv"};